import Vue from 'vue'
import Router from 'vue-router'

import List from './views/List'
import EditMilestone from './views/EditMilestone'
import Settings from './views/Settings'
import Milestone from './views/Milestone'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'List',
      component: List
    },
    {
      path: '/new',
      name: 'New',
      component: EditMilestone
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/milestones/:slug',
      name: 'Milestone',
      component: Milestone
    },
    {
      path: '/milestones/edit/:slug',
      name: 'EditMilestone',
      component: EditMilestone
    }
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
